
import InvestmentCard from "./InvestmentCard";
import { Investment } from "@/types/investment";

interface InvestmentListProps {
  investments: Investment[];
}

const InvestmentList = ({ investments }: InvestmentListProps) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Current Investment Opportunities</h2>
      
      {investments.map((investment) => (
        <InvestmentCard key={investment.id} investment={investment} />
      ))}
    </div>
  );
};

export default InvestmentList;
